export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-no-dogs-ddcf29078024140fa687f00968381623.svg";